'use client'
import RegisterForm from "@/app/components/pages/register/RegisterForm";
import {FormattedMessage} from "react-intl";
import Image from "next/image";
import styles from "@/app/styles/page/create-account/create-account-page.module.scss";
import {getCDNImage} from "@/app/utils/ImageUtil";

const Register = ({data}) => {
    const {create_account_title, create_account_text, create_account_image} = data.createAccount
    return (
        <div className={styles.createAccountContent}>
            <div className={styles.formsDiv}>
                <h1 className={styles.title}>
                    {create_account_title}
                </h1>
                <p className={styles.text}>
                    {create_account_text}
                </p>
                <RegisterForm createAccount={data.createAccount}/>
                {/*TODO: future social register*/}
                {/*<div className="textAfterForm">*/}
                {/*    <p><FormattedMessage id={'common.form.or'}/></p>*/}
                {/*</div>*/}
                {/*<div className="buttons-container">*/}
                {/*    <div className="btn-continue" onClick={() => signIn('google')}>*/}
                {/*        <Image*/}
                {/*            src={'/google-icon.png'}*/}
                {/*            alt="Google"*/}
                {/*            width={20}*/}
                {/*            height={20}*/}
                {/*            className="icon"*/}
                {/*        />*/}
                {/*        <p><FormattedMessage id={'common.form.continueGoogle'}/></p>*/}
                {/*    </div>*/}
                    {/*<div className="btn-continue" onClick={() => signIn()}>*/}
                    {/*    <Image*/}
                    {/*        src={'/linkedin-icon.png'}*/}
                    {/*        alt="Linkedin"*/}
                    {/*        width={20}*/}
                    {/*        height={20}*/}
                    {/*        className="icon"*/}
                    {/*    />*/}
                    {/*    <p><FormattedMessage id={'common.form.continueLinkedin'}/></p>*/}
                    {/*</div>*/}
                    {/*<div className="btn-continue" onClick={() => signIn()}>*/}
                    {/*    <Image*/}
                    {/*        src={'/facebook-icon.png'}*/}
                    {/*        alt="Facebook"*/}
                    {/*        width={20}*/}
                    {/*        height={20}*/}
                    {/*        className="icon"*/}
                    {/*    />*/}
                    {/*    <p><FormattedMessage id={'common.form.continueFacebook'}/></p>*/}
                    {/*</div>*/}
                {/*</div>*/}
            </div>
            <Image
                src={getCDNImage(create_account_image)}
                alt="Čovek sa poklonima"
                width={629}
                height={788}
                className={styles.image}
            />
        </div>
    )
}

export default Register